import React, { useState } from 'react';
import { signIn } from '../../FirebaseAuth';

const Login = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState(null);

    const handleLogin = async (e) => {
        e.preventDefault();
        setError(null);
        try {
            await signIn(email, password);
        } catch (err) {
            setError(err.message);
        }
    };

    return (
        <div className="flex min-h-screen">
            {/* Left Panel */}
            <div className="hidden lg:flex w-1/2 bg-blue-500 text-white flex-col items-center justify-center p-12 text-center">
                <h1 className="text-5xl font-bold mb-4">Start managing your school now!!</h1>
                <p className="text-lg">Welcome to our school management system, your all-in-one solution for management effortlessly.</p>
                <div className="mt-8">
                    <svg className="w-64 h-64 mx-auto text-black opacity-75" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10.394 2.08a1 1 0 00-.788 0l-7 3.5a1 1 0 00.788 1.84L10 9.14l6.606-1.72a1 1 0 00.788-1.84l-7-3.5zM3 8.394a1 1 0 00-.788 1.84l7 3.5a1 1 0 00.788 0l7-3.5a1 1 0 00-.788-1.84L10 10.86 3.394 8.394zM1 12.394a1 1 0 00.788 1.84l7 3.5a1 1 0 00.788 0l7-3.5a1 1 0 00-.788-1.84L10 14.86 1.394 12.394z"></path>
                    </svg>
                </div>
            </div>

            {/* Right Panel */}
            <div className="w-full lg:w-1/2 bg-white flex items-center justify-center p-6">
                <div className="w-full max-w-md">
                    {/* Logo */}
                    <div className="flex justify-center mb-6">
                        <div className="w-20 h-20 bg-blue-500 rounded-full flex items-center justify-center">
                            <span className="text-white text-4xl font-bold">SA</span>
                        </div>
                    </div>

                    <h2 className="text-3xl font-bold text-center mb-2">Sign In</h2>
                    <p className="text-center text-gray-500 mb-8">Please enter your details to log in.</p>

                    <form onSubmit={handleLogin}>
                        <div className="mb-4">
                            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="email">
                                Email
                            </label>
                            <input type="email" id="email" placeholder="your.email@example.com"
                                   value={email}
                                   onChange={(e) => setEmail(e.target.value)}
                                   className="shadow-sm appearance-none border rounded-lg w-full py-3 px-4 text-gray-700 leading-tight focus:outline-none focus:ring-2 focus:ring-blue-500" />
                        </div>

                        <div className="mb-6">
                            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="password">
                                Password
                            </label>
                            <input type="password" id="password" placeholder="************"
                                   value={password}
                                   onChange={(e) => setPassword(e.target.value)}
                                   className="shadow-sm appearance-none border rounded-lg w-full py-3 px-4 text-gray-700 leading-tight focus:outline-none focus:ring-2 focus:ring-blue-500" />
                        </div>

                        {error && <p className="text-red-500 text-xs italic mb-4">{error}</p>}

                        <div className="flex items-center justify-between">
                            <button type="submit" className="w-full bg-blue-500 hover:bg-blue-700 text-white font-bold py-3 px-4 rounded-lg focus:outline-none focus:shadow-outline">
                                Sign In
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default Login;
